import { render, staticRenderFns } from "./LangPicker.vue?vue&type=template&id=339e356f&scoped=true&"
import script from "./LangPicker.vue?vue&type=script&lang=js&"
export * from "./LangPicker.vue?vue&type=script&lang=js&"
import style0 from "./LangPicker.vue?vue&type=style&index=0&id=339e356f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339e356f",
  null
  
)

export default component.exports